export const PAYMENT_ACTION_TYPE = {
  paymentCardAdd: "paymentCardAdd",
  paymentCardAddMessage: "paymentCardAddMessage",
  paymentCardAddIdle: "paymentCardAddIdle",
  paymentModificationStatus: "paymentModificationStatus",
  paymentModificationStatusIdle: "paymentModificationStatusIdle",
  RESET:"RESET"
};
